import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./About.css";
import Icon from "./Icon.jsx";

import aboutImg1 from "../assets_optimized/hotel.webp";
import aboutImg2 from "../assets_optimized/curated.webp";
import aboutImg3 from "../assets_optimized/aesthetic.webp";

import team1 from "../assets_optimized/team1.webp";
import team2 from "../assets_optimized/team2.webp";
import team3 from "../assets_optimized/team3.webp";
import team4 from "../assets_optimized/team4.webp";

export default function About() {
  const slides = useMemo(
    () => [
      {
        title: "Boutique Expertise",
        desc:
          "Specialized in creating elegant hotel interiors and luxury residential spaces with a refined, boutique approach.",
        image: aboutImg1,
      },
      {
        title: "Curated Collections",
        desc:
          "Handpicked furniture and décor pieces selected for their craftsmanship, elegance, and timeless appeal.",
        image: aboutImg2,
      },
      {
        title: "Refined Aesthetics",
        desc:
          "Timeless design language that blends classic elegance with contemporary luxury, crafted with precision.",
        image: aboutImg3,
      },
    ],
    []
  );

  const team = useMemo(
    () => [
      {
        name: "Er. Bhargava Dasari",
        role: "Civil Engineer, MBA ACM",
        desc:
          "Passionate about turning interior concepts into perfectly executed spaces. Into management of projects.",
        image: team1,
      },
      {
        name: "Er. Suhas Dasari",
        role: "Civil Engineer, MBA ACM",
        desc:
          "Strategically managing interiors with a focus on quality and timelines.",
        image: team2,
      },
      {
        name: "Er. Nikhitha Vemula",
        role: "Civil Engineer",
        desc:
          "I am a design analyst and an on site execution expert, turning the spaces into realistic output.",
        image: team3,
      },
      {
        name: "Ar. Charitha Raghu",
        role: "Landscape Interior Architect",
        desc:
          "I shape environments with a distinct landscape language, focused on sustainability and human experience through LumiScapes Landscape Architects.",
        image: team4,
      },
    ],
    []
  );

  const [active, setActive] = useState(0);
  const [displayed, setDisplayed] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((p) => (p + 1) % slides.length);
    }, 4500);
    return () => clearInterval(id);
  }, [slides.length]);

  useEffect(() => {
    if (active === displayed) return;

    setIsFading(true);

    const t1 = setTimeout(() => {
      setDisplayed(active);
      requestAnimationFrame(() => setIsFading(false));
    }, 220);

    return () => clearTimeout(t1);
  }, [active, displayed]);

  const current = slides[displayed];

  return (
    <>
      {/* ABOUT SECTION (unchanged) */}
      <section className="section aboutSection" id="about">
        <div className="container aboutWrap">
          <div className="aboutTopCenter">
            <div className="aboutKicker">
              <span className="aboutDot" aria-hidden="true" /> About Us
            </div>
            <h2 className="aboutTitle">Elegant Design. Refined Luxury.</h2>
            <p className="aboutText">
              We are a boutique design studio specializing in elegant,
              sophisticated interiors for hotels and luxury spaces. Our team
              combines timeless elegance with contemporary luxury, creating
              environments that captivate discerning clients.
            </p>
          </div>

          <div className="aboutGridNew">
            <div className="aboutLeftNew">
              <div className="aboutImgCard card">
                <div className="aboutImgFrame">
                  {slides.map((s, i) => (
                    <img
                      key={s.title}
                      className={`aboutImg ${i === active ? "isActive" : ""}`}
                      src={s.image}
                      alt={s.title}
                      loading="lazy"
                    />
                  ))}
                  <div className="aboutImgShade" />
                </div>

                <div className="aboutDots">
                  {slides.map((_, i) => (
                    <button
                      key={i}
                      className={`aboutDotBtn ${i === active ? "isActive" : ""}`}
                      onClick={() => setActive(i)}
                      type="button"
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="aboutRightNew">
              <div className="aboutSideSingle">
                <div className={`aboutActiveContent ${isFading ? "isFading" : ""}`}>
                  <div className="aboutActiveTop">
                    <div className="aboutActiveKicker">
                      <span className="aboutActiveIndex">
                        {String(displayed + 1).padStart(2, "0")}
                      </span>
                      <span className="aboutActiveLabel">Highlight</span>
                    </div>
                    <span className="aboutActiveArrow">
                      <Icon name="arrow" />
                    </span>
                  </div>

                  <h3 className="aboutActiveTitle">{current.title}</h3>
                  <p className="aboutActiveDesc">{current.desc}</p>
                </div>

                <div className="aboutSideActions">
                  <Link to="/contact" className="btn btnPrimary">
                    Get in Touch <Icon name="arrow" />
                  </Link>
                  <Link to="/gallery" className="btn">
                    View Portfolio <Icon name="arrow" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TEAM SECTION */}
      <section className="section teamSection" id="team">
        <div className="container teamWrap">
          <div className="teamTop">
            <div className="teamKicker">
              <span className="teamDot" /> Our Team
            </div>
            <h2 className="teamTitle">People Behind the Craft</h2>
            <p className="teamText">
              A focused team committed to premium interiors and refined execution.
            </p>
          </div>

          <div className="teamGrid">
            {team.map((m) => (
              <article className="teamCard card" key={m.name}>
                <img className="teamBgImage" src={m.image} alt={m.name} loading="lazy" />

                <div className="teamContent">
                  <div className="teamAvatarWrap">
                    <img
                      className="teamAvatar"
                      src={m.image}
                      alt={m.name}
                      loading="lazy"
                    />
                  </div>

                  <h3 className="teamName">{m.name}</h3>
                  <p className="teamRole">{m.role}</p>
                  <p className="teamDesc">{m.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}




